import { i18nMark } from 'lingui-react';

const messages = {
  caseTitle: i18nMark('Case {caseId}'),
  complaint: i18nMark('Complaint'),
  created: i18nMark('Created'),
  estimate: i18nMark('Estimate'),
  etr: i18nMark('ETR'),
  followUp: i18nMark('Follow-Up'),
  notes: i18nMark('Notes'),
  serviceProvider: i18nMark('Service Provider'),
  status: i18nMark('Status'),
  title: i18nMark('Open Events'),
  undefinedComplaint: i18nMark('No complaints yet'),
  unreadNotesCount: i18nMark('{count} Unread'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/OpenEventsWidget/messages.js